import { cn } from '@/lib/utils';

/**
 * Espaço reservado durante o carregamento.
 *
 * A diretriz da seção 14 do plano pede skeletons em vez de páginas vazias: o
 * usuário vê a forma do conteúdo que está por vir, em vez de um branco que
 * parece falha.
 */
export function Esqueleto({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      className={cn('bg-silenciado animate-pulse rounded-md', className)}
      aria-hidden="true"
      {...props}
    />
  );
}

/** Linhas de esqueleto para o corpo de uma tabela. */
export function EsqueletoTabela({ linhas = 5, colunas }: { linhas?: number; colunas: number }) {
  return (
    <>
      {Array.from({ length: linhas }, (_, indice) => (
        <tr key={indice} className="border-borda border-b">
          {Array.from({ length: colunas }, (_, coluna) => (
            <td key={coluna} className="px-4 py-3">
              <Esqueleto className="h-4 w-full max-w-40" />
            </td>
          ))}
        </tr>
      ))}
      <tr className="apenas-leitor-tela">
        <td colSpan={colunas} role="status">
          Carregando dados…
        </td>
      </tr>
    </>
  );
}
